import { Injectable } from '@angular/core';
import { PriceAlert } from '@models/price-alerts.class';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AppState } from 'src/app';
import { ApiGatewayService } from 'src/shared';

@Injectable()
export class PriceAlertsService {
  private contractRoute: string;
  private allContractsRoute: string;
  private alertsAPI: string;

  constructor(
    private store: Store<AppState>,
    private readonly apiGatewayService: ApiGatewayService,
  ) {
    this.store
      .select('config')
      .pipe(
        map((res: any) => res.toJS()),
        first(),
      )
      .subscribe((value) => {
        this.alertsAPI = value.priceAlertsApi;
      });
  }

  public initializeRoute(contractId: string) {
    this.allContractsRoute = `${this.alertsAPI}v1/accounts/alerts`;
    this.contractRoute = `${this.alertsAPI}v1/accounts/${contractId}/alerts`;
  }

  public getAlerts(): Observable<PriceAlert[]> {
    /**
     * TODO: If we change our apiGatewayService and allow us to
     * type the responses with custom types, we can remove
     * the ( as unknown) as Observable<MyExpectedType>; and just do
     * .get<MyExpectedType>
     */
    return this.apiGatewayService.get(this.contractRoute) as any as Observable<
      PriceAlert[]
    >;
  }

  public getAllAlerts(): any {
    return this.apiGatewayService.get(
      this.allContractsRoute,
    ) as any as Observable<PriceAlert[]>;
  }

  public createAlert(alert: PriceAlert): Observable<PriceAlert> {
    return this.apiGatewayService.post(
      this.contractRoute,
      alert,
    ) as any as Observable<PriceAlert>;
  }

  public editAlert(alertId: string, alert: PriceAlert): Observable<any> {
    return this.apiGatewayService.put(
      `${this.contractRoute}/${alertId}`,
      alert,
    );
  }

  public deleteAlert(alertId: string): Observable<any> {
    return this.apiGatewayService.delete(`${this.contractRoute}/${alertId}`);
  }
}
